export const Plan_SET_DATE = 'SET_DATE'
export const Plan_SET_NEXT_DATE = 'SET_NEXT_DATE'
export const Plan_SET_PREVIOUS_DATE = 'SET_PREVIOUS_DATE'
export const Plan_SET_ROUTELOCATIONS = 'SET_ROUTELOCATIONS'
export const Plan_SET_ROUTE = 'SET_ROUTE'
export const Plan_SET_LOCATION = 'SET_LOCATION'
export const Plan_SET_EVENT_FOCUSLIST = 'SET_EVENT_FOCUSLIST'
